<script lang="ts">
	import GlassEffect from '#lib/modern/GlassEffect.svelte';
	import Popin from '#lib/modern/Popin.svelte';
	import type { Snippet } from 'svelte';

	interface Props {
		align?: 'left' | 'right' | 'center';
		valign?: 'top' | 'bottom' | 'center';
		marginTop?: number;
		marginLeft?: number;
		targetElement: HTMLElement | string;
		padding?: string;
		paddingBorder?: string;
		children?: Snippet;
		onclose?: (id: string) => void;
		legacyDesign?: boolean;
		displayWidget?: boolean;
		maxWidth?: string;
		maxHeight?: string;
		minWidth?: string;
		color?: string | number;
		id?: string;
		zIndex?: string;
		className?: string;
	}

	let {
		align = 'center',
		valign = 'bottom',
		marginTop = 2,
		marginLeft = 0,
		targetElement,
		padding = 'p-8',
		paddingBorder = 'p-1',
		children,
		onclose = (_id: string) => {},
		legacyDesign = false,
		displayWidget = false,
		maxWidth = 'sm:max-w-lg',
		maxHeight = 'max-h-full',
		minWidth = 'min-w-fit',
		color = 3,
		id = '',
		zIndex = 'z-50',
		className = ''
	}: Props = $props();

	const _id = $derived(id);

	let effectiveLegacyDesign = $derived(displayWidget ? false : legacyDesign);
	let effectiveColor = $derived(displayWidget ? 'widget-background' : color);
</script>

<Popin
	onclose={() => onclose(_id)}
	{targetElement}
	{align}
	{valign}
	{marginTop}
	{marginLeft}
	{zIndex}
>
	<GlassEffect
		className="{effectiveLegacyDesign
			? 'border! !border-border !dark:border-border-dark text-surface-on dark:text-surface-dark-on bg-surface/95! dark:bg-surface-dark/95! backdrop-blur-xl!'
			: displayWidget
				? 'border border-widget-primary/30 dark:border-widget-primary-dark/30 bg-widget-background dark:bg-widget-background-dark backdrop-blur-xl'
				: 'border border-white/10 backdrop-blur-xl'}
			{maxWidth} {maxHeight} w-full {minWidth} h-fit
			rounded-3xl shadow-2xl
			{paddingBorder} flex {className}
			"
		classContent="flex flex-col flex-1 overflow-hidden"
		color={effectiveLegacyDesign ? 9 : effectiveColor}
		blur
		legacyDesign={effectiveLegacyDesign}
		><div
			class="overflow-auto flex-1 min-h-0 {padding} {displayWidget
				? 'text-widget-background-on dark:text-widget-background-dark-on'
				: ''}"
		>
			{@render children?.()}
		</div>
	</GlassEffect>
</Popin>
